// @flow
import * as React from 'react';
import Layout from 'layouts/Layout';
import ErrorPage from 'pages/ErrorPage';
import LoadingPage from 'pages/LoadingPage';

type Props = {
  error: Object,
  pastDelay: boolean
};

export default class LoadableLoadingPage extends React.PureComponent<Props> {
  render() {
    if (this.props.error) {
      return <ErrorPage error={this.props.error} />;
    }
    if (this.props.pastDelay) {
      return <LoadingPage delay={0} />;
    }
    return <Layout />;
  }
}
